import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { benchmarkkpi, tranbenchmarkkpi, practicebmtransactionadd, BMProjectActionsHistory } from './../../../../models/slakpi';
import { division, user, department, targetMaster, benchmarkprogressmaster } from './../../../../models/admin';
import { UtilityService } from '../../../../services/utility.service';
import { BMApiService } from '../../../../services/bm.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from '../../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  OnEventArgs,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminApiService } from '../../../../services/admin.service';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-practice-bm-progress-transaction-approved-list',
  templateUrl: './practice-bm-progress-transaction-approved-list.component.html',
  styleUrls: ['./practice-bm-progress-transaction-approved-list.component.css']
})
export class PracticeBMProgressTransactionApprovedListComponent implements OnInit {
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  modalRefAtt: BsModalRef;
  modalRefAttAll: BsModalRef;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  @ViewChild('attachmentTemplate', { static: false }) attachmentTemplate: TemplateRef<any>;
  @ViewChild('allAttachmentTemplate', { static: false }) allAttachmentTemplate: TemplateRef<any>;
  
  @ViewChild('progressStatusUpdateTemplate', { static: false }) progressStatusUpdateTemplate: TemplateRef<any>;
  @ViewChild('prjectInfo', { static: false }) prjectInfo: TemplateRef<any>;
  columnDefinitions: Column[];
  histroyColumnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  public selTab = true;
  public data: any;
  public gridload: number = 0;
  submitted: boolean = false;

  invalid: boolean = false;
  public loading: boolean = true;
  public pageAction: string = 'add';
  objPM: any = new benchmarkprogressmaster();
  objProject: any = new practicebmtransactionadd();
  angularGrid: AngularGridInstance;
  bmProgressMasterData: object[];
  selected_itemUno: number = 0;
  pbmtype: any;
  isTitle: boolean = false;
  continentDDList: any = [];
  isContinentDD: boolean = false;
  titleName: string;
  Title2: boolean;
  countryDDList: any;
  isCountryDD: boolean = false;
  isRegionDD: boolean = false;
  sourceTypeDDList: any = [];
  regionDDList: any = [];
  isSourceTypeDD: boolean = false;
  isSourceDesc: boolean = false;
  utilityTypeDDList: any = [];
  peerTypeDDList: any = [];
  isUtilityTypeDD = false;
  isPeerTypeDD = false;
  isBusinessModel: boolean = false;
  isTechnologyUsed: boolean = false;
    bmProgressTypeDDList: Object;
    editlabel: string;
    transactionRoutingLink: string;
  searchText: string;

  user: any = {};
  login_UserID: string;
  isAdmin: boolean = false;
    projectActionsHistoryData: any;
    projectActionsHistoryDataSet: any[];
    projectActionsHistoryDataSetFull_DD: any;
    projectActionsHistoryDataSetFull: any[];
    itemUno: number;
    attachementList: any[];
    progressActualTotal: any;
    progressTargetTotal: any;
    attachementListAll: any=[];
  selTab2: boolean = false;
  selTab3: boolean = false;
  selTab4: boolean = false;
    getAttachmentID: any;
  dataSearch: any[];
  tenantUno: any;
  noDataImg: any;
  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  constructor(private formBuilder: FormBuilder, public restApi: AdminApiService, public restBMApi: BMApiService,private route: ActivatedRoute,
    public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.tenantUno = this.user.tenantUno;
    this.noDataImg = this.utilityService.getnodataImage();
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission

  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Practice Benchmark Status");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }

  ngOnInit() {
    this.userService.CheckLogin();
    //this.modalRef.hide();
    //this.modalRefAtt.hide();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
  
    this.loadPerformanceMaster();
    this.getBMProgressTypeDD();
    
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' ';

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' ';

  }
  
  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.projectName && a.projectName.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.division && a.division.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.projectManager && a.projectManager.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.plannedStartDate && a.plannedStartDate.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.plannedEndDate && a.plannedEndDate.toLowerCase().includes(this.searchText.toLowerCase()))
       // || (a.attachementCount && a.attachementCount.toLowerCase().includes(this.searchText.toLowerCase()))
        );
    }
    else
      this.dataset = this.dataSearch;
  }

  setGridBMProgressDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'projectName', name: 'Project Name', field: 'projectName', sortable: true, type: FieldType.string, filterable: true, width: 80,
        filter: {
          collection: this.uniqueArray(this.dataset, 'projectName', 'projectName'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'division', name: 'Division', field: 'division', sortable: true, type: FieldType.string, filterable: true, width: 60,
        filter: {
          collection: this.uniqueArray(this.dataset, 'division', 'division'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'projectManager', name: 'Project Manager', field: 'projectManager', sortable: true, type: FieldType.string, filterable: true, width: 60,
        filter: {
          collection: this.uniqueArray(this.dataset, 'projectManager', 'projectManager'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'plannedStartDate', name: 'Planned Start', field: 'plannedStartDate', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'plannedStartDate', 'plannedStartDate'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'plannedEndDate', name: 'Planned End', field: 'plannedEndDate', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'plannedEndDate', 'plannedEndDate'),
          model: Filters.multipleSelect,

        }
      },
     
      {
        id: 'percentageActual', name: 'Percentage', field: 'percentageActual', sortable: true, type: FieldType.string, filterable: true, width: 50,
        formatter: (row, cell, val, columnDef, data) => {
          let per = data.percentageActual;

          return '<div class="progress" style="height: 15px; font-size:9px; text-indent: 2px; background-color:#999;"><div class="progress-bar bg-d-green text-left" role = "progressbar" style = "width:' + per + '%;" aria-valuenow="'+per+'" aria-aluemin="0" aria - valuemax="100" > ' +per+'% </div></div>';

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'percentageActual', 'percentageActual'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'attachementCount', name: 'Files', field: 'attachementCount', sortable: true, type: FieldType.string, filterable: true, formatter: this.actualFormatter_main, width: 30, 
        filter: {
          collection: this.uniqueArray(this.dataset, 'attachementCount', 'attachementCount'),
          model: Filters.multipleSelect,

        },
        onCellClick: (e: Event, args: OnEventArgs) => {
          
          let data = args.dataContext;
          this.getAttachmentID = data.id;
          this.loadAllAttachment(data.id, 'Plan');
          this.modalRefAttAll = this.modalService.show(
            this.allAttachmentTemplate,
            Object.assign({}, {
              class: 'gray modal-lg',
              backdrop: true,
              keyboard: true,
              focus: true,
              show: false,
              ignoreBackdropClick: true,
              animated: true
            })
          );
        }


      },
      {
        id: 'currentAction', name: 'Status', field: 'currentAction', sortable: true, type: FieldType.string, filterable: true, width: 30,
        formatter: (row, cell, val, columnDef, data) => {
          if (data.currentAction == 8 )
            return '<span  class="status-area status-green">ADAPT</span>';
          else if (data.currentAction == 6)
            return '<span  class="status-area status-orange">COLLECT</span>';
          else if (data.currentAction == 7)
            return '<span  class="status-area status-yellow">ANALYSE</span>';
          else
            return '<span  class="status-area status-red">PLAN</span>';
         
        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'currentAction', 'currentAction'),
          model: Filters.multipleSelect,

        }
      },
      
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 20,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          
          commandItems: [
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: this.editlabel,
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                let itemID = rdata.id;
                this.itemUno = rdata.id;
               
                this.router.navigate([this.transactionRoutingLink], { queryParams: { itemUno: itemID } });

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Progress History',
              iconCssClass: 'fa fa-commenting fa-lg red-txt Blink', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                
                
                let rdata: any = args.dataContext;
                let itemID = rdata.id;
                this.itemUno = rdata.id;

               
                this.loadBMProjectActionsHistory();
                this.modalRef = this.modalService.show(
                  this.progressStatusUpdateTemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Project Info',
              iconCssClass: 'fa fa-lg fa-info-circle', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                let itemID = rdata.id;
                this.itemUno = rdata.id;
                this.objProject.projectName =rdata.projectName;
                this.objProject.comments =rdata.comments;
                this.objProject.peer = rdata.peer;
                this.objProject.division = rdata.division;
                this.objProject.projectManager = rdata.projectManager;
                this.objProject.projectMemberName = rdata.projectMemberName;
                this.objProject.projectMember = (rdata.projectMember) ? this.utilityService.CommaSeperatorToArray(rdata.projectMember.toString()) : [];
                this.objProject.corporateStrategic = (rdata.corporateStrategic) ? this.utilityService.CommaSeperatorToArray(rdata.corporateStrategic.toString()) : [];
                this.objProject.firstAssingedApproversName = rdata.firstAssingedApproversName;
                this.objProject.secondAssingedApproversName = rdata.secondAssingedApproversName;
                this.objProject.thirdAssingedApproversName = rdata.thirdAssingedApproversName;
                this.objProject.plannedStartDate = rdata.plannedStartDate;
                this.objProject.plannedEndDate = rdata.plannedEndDate;


                this.modalRef = this.modalService.show(
                  this.prjectInfo,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
         


          ],

        }
      }

    ]


  }

 
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  loadPerformanceMaster() {
    this.spinner.show();
    let inpValue = new practicebmtransactionadd();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.flag = 'Transaction';
    inpValue.tenantUno = this.tenantUno;
    this.restBMApi.getProjects(inpValue)
      .subscribe(data => {
        
        const mockDataset = [];
          let filterDataSet = [];
          filterDataSet = uniqBy(data, 'id');
        
          this.data = filterDataSet.filter(a => a.status == 'Approved');
          this.editlabel = "Update Progress";
          this.transactionRoutingLink = '/practice-bm-progress-transaction';
        //let progressTargetTotal: any = [];
        //for (let i = 0; i < filterDataSet.length; i++) {
        //  progressTargetTotal.push(parseInt(filterDataSet[i].percentageTarget));
        //}
        //if (progressTargetTotal.length > 0) {
        //  this.progressTargetTotal = progressTargetTotal.reduce((a, b) => a + b, 0);
        //}
        //else {
        //  this.progressActualTotal = 0;
        //}

        ////Actual Total Percetage
        //let ActualTarget: any = [];
        //for (let i = 0; i < filterDataSet.length; i++) {
        //  ActualTarget.push(parseInt(filterDataSet[i].percentageActual));
        //}
        //if (ActualTarget.length > 0) {
        //  let percetageConvert = ActualTarget.reduce((a, b) => a + b, 0);
        //  this.progressActualTotal = (percetageConvert / this.progressTargetTotal) * 100;
        //}
        //else {
        //  this.progressActualTotal = 0;
        //}
        for (let i = 0; i < this.data.length; i++) {

          mockDataset[i] = {
            id: this.data[i].id,
            projectName: this.data[i].projectName,
            division: this.data[i].division,
            projectManager: this.data[i].projectManager,
            peer: this.data[i].peer,
            comments: this.data[i].comments,
            currentAction: this.data[i].currentAction,
            projectMember: this.data[i].projectMember,
            projectMemberName: this.data[i].projectMemberName,
            corporateStrategic: this.data[i].corporateStrategic,
            plannedStartDate: formatDate(this.data[i].plannedStartDate, 'dd-MM-yyy', 'en-US'),
            plannedEndDate: formatDate(this.data[i].plannedEndDate, 'dd-MM-yyy', 'en-US'),
            firstAssingedApproversName: this.data[i].firstAssingedApproversName,
            secondAssingedApproversName: this.data[i].secondAssingedApproversName,
            thirdAssingedApproversName: this.data[i].thirdAssingedApproversName,
            status: this.data[i].status,
            percentageActual: this.data[i].percentageActual,
            percentageTarget: this.data[i].percentageTarget,
            attachementCount: this.data[i].attachementCount

           
          };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridBMProgressDefn();
        }
        else {
          this.setGridBMProgressDefn();
        }
        this.bmProgressMasterData = mockDataset;
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  loadAllAttachment(id:any,type:any) {
    this.spinner.show();
    let inpValue = new BMProjectActionsHistory();
    inpValue.languageUno = 1033;
    inpValue.itemUno = id;
    inpValue.condition =3;
    inpValue.userUno = this.login_UserID;
    this.restBMApi.getAllAttachment(inpValue)
      .subscribe(data => {
        
        if (data != null) {
          let attList: any;
          attList = data;
          this.attachementListAll = attList.filter(a => a.actionType == type);
          //this.attachementListAll = data;
        }
        else {
          this.attachementListAll = [];
        }
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  openModalWithClass(addtemplate: TemplateRef<any>) {
    
    this.pageAction == "add";
    this.objPM = new benchmarkprogressmaster();

    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  onSubmit(val1) {
    
    if (!val1) { Swal.fire('Error', 'Please enter the required information.', 'error'); return }

    else {
      this.AddEditPerformanceMaster(this.objPM)
    }
  }

  AddEditPerformanceMaster(data1: any) {
    
    //if (this.kpiForm.invalid) {
    //  Swal.fire('Error', 'Something went wrong!', 'error')
    //  return false;
    //}


    if (this.DuplicateNameCheck(this.utilityService.isNumericNull(data1.id), this.utilityService.isStringNull(data1.bmProgressName), '')) {
      Swal.fire('Error', 'Duplicates are not allowed', 'warning');
      return false;
    }
    else {

      let objPF = new benchmarkprogressmaster();
      objPF = data1;
      objPF.bmProgressName = (objPF.bmProgressName) ? objPF.bmProgressName.toString() : '';
      objPF.bmProgressValue = (objPF.bmProgressValue) ? objPF.bmProgressValue : 0;
      objPF.bmProgressTypeUno = objPF.bmProgressTypeUno;
      objPF.userUno = this.login_UserID;
      objPF.condition = (this.pageAction == "add") ? 0 : 1;
      objPF.tenantUno = this.tenantUno;
      objPF.tableName = this.pbmtype;
      this.restApi.addEditBMProgressMaster(objPF)
        .subscribe(data => {

          if (data != null && data != undefined && data != '') {
            Swal.fire('Error', 'Something went wrong', 'error');
            this.spinner.hide();
          }
          else {
            Swal.fire({
              type: 'success',
              title: 'Item saved.',
              showConfirmButton: false,
              timer: 1500
            })
            setTimeout(() => {
              this.objPM = new benchmarkprogressmaster();
              this.spinner.hide();
              this.loadPerformanceMaster();
              this.modalRef.hide();
            }, 500);

          }



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
    }
  }
  DuplicateNameCheck(itemUno: number, nameEn: string, nameAr: string) {
    
    if (this.data != null && this.data != undefined) {
      var rtnValue = false;
      this.data.forEach((grdData) => {
        if (((itemUno != grdData.id) || (itemUno == grdData.id && this.selected_itemUno != grdData.id))
          &&
          (grdData.bmProgressName.toLocaleLowerCase() == nameEn.trim().toLowerCase())) {
          rtnValue = true;
        }
      

      });

      return rtnValue;
    }
  }


  DeletePerformanceMaster(data1: any) {
    
    let objpfm = new benchmarkprogressmaster();
    objpfm.actionType = this.pageAction;
    objpfm.id = data1.id;
    objpfm.userUno = this.login_UserID;
    objpfm.tenantUno = 1;
    objpfm.tableName = this.pbmtype;
    this.restApi.deleteBMProgressMaster(objpfm)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          Swal.fire('Error', 'Something went wrong!', 'error')
        }
        else {
          Swal.fire({
            type: 'success',
            title: 'Item deleted.',
            showConfirmButton: false,
            timer: 1500
          })
          this.loadPerformanceMaster();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }


  getBMProgressTypeDD() {

    let inpValue = new benchmarkprogressmaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getBMProgressTypeDD(inpValue)
      .subscribe(data => {

        this.bmProgressTypeDDList = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  
  Reset() {
    this.modalRef.hide();
    setTimeout(() => {
      this.objPM = new benchmarkprogressmaster();
      this.pageAction = 'add';
    }, 300);



  }
 

  loadBMProjectActionsHistory() {
  
    let valuePer: any = [];
    this.spinner.show();
    let inpValue = new BMProjectActionsHistory();
    inpValue.languageUno = 1033;
    inpValue.itemUno = this.itemUno;
    inpValue.condition = 3;
    inpValue.userUno = this.login_UserID;

    this.restBMApi.getBMProjectActionHistory(inpValue)
      .subscribe(data => {
        

        this.projectActionsHistoryData = uniqBy(data, 'id');



        const mockDataset = [];
        for (let i = 0; i < this.projectActionsHistoryData.length; i++) {

          mockDataset[i] = {
            id: this.projectActionsHistoryData[i].id,
            actionTrnUno: this.projectActionsHistoryData[i].actionTrnUno,
            projectUno: this.projectActionsHistoryData[i].projectUno,
            fileName: this.projectActionsHistoryData[i].fileName,
            fileContent: this.projectActionsHistoryData[i].fileContent,
            contentType: this.projectActionsHistoryData[i].contentType,
            comments: this.projectActionsHistoryData[i].comments,
            actionType: this.projectActionsHistoryData[i].actionType,
            actionText: this.projectActionsHistoryData[i].actionText,
            actionStatus: this.projectActionsHistoryData[i].actionStatus,
            enteredDate: this.projectActionsHistoryData[i].enteredDate,
            progress: this.projectActionsHistoryData[i].progress,
            progressPrecentage: this.projectActionsHistoryData[i].progress + '%',
            remarks: this.projectActionsHistoryData[i].remarks
          };
        }



        //document.getElementById("planprogress").style.width = this.percentageTotal + "%";
        this.projectActionsHistoryDataSet = mockDataset;
        this.projectActionsHistoryDataSetFull = mockDataset;
        this.projectActionsHistoryDataSetFull_DD = uniqBy(data, 'actionType');
        if (mockDataset.length > 0) {
          this.setGridBMProjectActionsHistoryDefn();
        }
        else {
          this.setGridBMProjectActionsHistoryDefn();
          this.projectActionsHistoryDataSet = [];
        }

        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  setGridBMProjectActionsHistoryDefn() {
    let temp = this;
    this.histroyColumnDefinitions = [

      {
        id: 'actionType', name: 'Type', field: 'actionType', sortable: true, type: FieldType.string, filterable: false

      },
      {
        id: 'actionText', name: 'Action', field: 'actionText', sortable: true, type: FieldType.string, filterable: false

      },
      {
        id: 'actionStatus', name: 'Status', field: 'actionStatus', sortable: true, type: FieldType.string, filterable: false

      },
      {
        id: 'progressPrecentage', name: 'Progress', field: 'progressPrecentage', sortable: true, type: FieldType.string, filterable: false

      },
      {
        id: 'remarks', name: 'Risk', field: 'remarks', sortable: true, type: FieldType.string, filterable: false

      },
      {
        id: 'enteredDate', name: 'Updated On', field: 'enteredDate', sortable: true, type: FieldType.string, filterable: false

      },
      {
        id: 'fileName', name: 'Files', field: 'fileName', sortable: true, type: FieldType.string, filterable: false, formatter: this.actualFormatter, width: 30,
        onCellClick: (e: Event, args: OnEventArgs) => {
          
          let data = args.dataContext;
          if (data.fileName != '') {
            if (data.fileName != "") {
              this.attachementList = this.projectActionsHistoryDataSet.filter(a => a.id == data.id);
            }
            else {
              this.attachementList = [];
            }

            this.modalRefAtt = this.modalService.show(
              this.attachmentTemplate,
              Object.assign({}, {
                class: 'gray modal-lg',
                backdrop: true,
                keyboard: true,
                focus: true,
                show: false,
                ignoreBackdropClick: true,
                animated: true
              })
            );
            return '1';
          }
          else if (data.fileName != '') {
            return '0';
          }

        }
      },
    



    ]


  }
  
  actualFormatter: Formatter = (row, cell, value, columnDef, data) => {


    if ((data.fileName != '')) {
      return '<a matTooltipClass="my-custom-tooltip-avg" title="File Download"  class="bcopy-btn" style="cursor:pointer !important;"><i class="fa fa-file-o"></i></a>'
    }
    else {
      return ''
    }


  };
  actualFormatter_main: Formatter = (row, cell, value, columnDef, data) => {


    if ((data.attachementCount != '' && data.attachementCount != '0')) {
      return '<a matTooltipClass="my-custom-tooltip-avg" title='+ data.attachementCount+'  class="bcopy-btn" style="cursor:pointer !important;"><i class="fa fa-file-o"></i></a>'
    }
    else {
      return ''
    }


  };

  getFileIconClass(fileTitle: string) {

    if (fileTitle == '' || fileTitle == null)
      return "fa fa-file";

    var rtnClass = "fa fa-file";
    var strTitle = (fileTitle.indexOf('.') > 0) ? fileTitle.split('.')[1].toLowerCase() : 'unknown';

    switch (strTitle) {
      case 'txt':
        rtnClass = "fa fa-file-o";
        break;
      case 'doc':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'docx':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'xls':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'xlsx':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'pdf':
        rtnClass = "fa fa-file-pdf-o";
        break;
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
        rtnClass = "fa fa-file-picture-o";
        break;
      case 'mp3':
        rtnClass = "fa fa-file-audio-o";
        break;
      case 'mp4':
      case 'mpeg':
      case 'mpg':
      case 'avi':
        rtnClass = "fa fa-file-video-o";
        break;
      default:
        rtnClass = "fa fa-file";
        break;
    }

    return rtnClass;

  }

  AttachmentDownload(id: any, name: string) {
    let inpValue = new BMProjectActionsHistory();
    inpValue.languageUno = 1033;
    inpValue.itemUno = id;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restBMApi.DownloadBMProjectActionHistoryFile(inpValue).subscribe(
      data => {
        
        this.spinner.hide();
        if (data != null) {
          
          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            window.navigator.msSaveBlob(data, name);
          }
          else //Chrome & FF
          {
            var url = window.URL.createObjectURL(data);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
          }

        }
        else {
          this.spinner.hide();
          Swal.fire('Error', 'Something went wrong', 'error');
        }
      },
      error => {
        Swal.fire('Error', 'Something went wrong', 'error')
        this.spinner.hide();
      },
      () => {
        // 'onCompleted' callback.
        this.spinner.hide();

      }
    );

  }

  onChangeTab(selectedTab: any) {
    if (selectedTab == 'plan') {
      this.selTab = true;
      this.selTab2 = false;
      this.selTab3 = false;
      this.selTab4 = false;
    }
    else if (selectedTab == 'collect') {
      this.selTab = false;
      this.selTab2 = true;
      this.selTab3 = false;
      this.selTab4 = false;

    }
    else if (selectedTab == 'analyze') {
      this.selTab = false;
      this.selTab2 = false;
      this.selTab3 = true;
      this.selTab4 = false;

    }
    else if (selectedTab == 'adapt') {
      this.selTab = false;
      this.selTab2 = false;
      this.selTab3 = false;
      this.selTab4 = true;

    }
    return false;
  }
}
